import { render, staticRenderFns } from "./StatsOverview.vue?vue&type=template&id=e560f4a4&scoped=true"
import script from "./StatsOverview.vue?vue&type=script&lang=js"
export * from "./StatsOverview.vue?vue&type=script&lang=js"
import style0 from "./StatsOverview.vue?vue&type=style&index=0&id=e560f4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e560f4a4",
  null
  
)

export default component.exports